const Footer = () => {
    return <div className='w-screen bg-gray-800' style={{minHeight:'30vh'}}>
      <div className='m-20 z-10 text-2xl text-center'>
      <p className="text-white">Made with ❤ by Delta Force</p>
      </div>
      <div className='bg-gray-700 ' style={{height:'2px', width:'86%',marginLeft:'7%'}}>.</div>
    </div>;
  };
  
  export default Footer;